import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Box } from '@mui/material'
import XeroContactsTable from '../../../components/XeroContactsTable'
import { generateInspectorTitle } from '../../../contexts/InspectorContext'
import { useInspectorRef } from '../../../hooks/useInspectorRef'

const InspectorClients: React.FC = () => {
  const { fpCode: fp_code } = useInspectorRef()

  if (!fp_code) {
    return (
      <Box>
        <p>Invalid URL parameters</p>
      </Box>
    )
  }

  return (
    <>
      <Helmet>
        <title>{generateInspectorTitle('Clients')}</title>
      </Helmet>

      <Box>
        <XeroContactsTable fpCode={fp_code} />
      </Box>
    </>
  )
}

export default InspectorClients